import { useContext } from "react";

import {
  SharedAppContext,
  ISharedAppContext,
} from "@origin-digital/shared-app-context";

const useSharedAppContext = (): ISharedAppContext =>
  useContext<ISharedAppContext>(SharedAppContext);

export { useSharedAppContext, ISharedAppContext };
